const savingActionTypes = {
  DELETE_SITE_META: 'DELETE_SITE_META',
  SET_SITE_META: 'SET_SITE_META',
  DELETE_ASSET: 'DELETE_ASSET',
  SET_ASSET: 'SET_ASSET',
  SET_SITE_NAME: 'SET_SITE_NAME',
  CREATE_SITE_PROPERTY: 'CREATE_SITE_PROPERTY',
  SET_SITE_PROPERTY: 'SET_SITE_PROPERTY',
  UPDATE_CUSTOMIZATION: 'UPDATE_CUSTOMIZATION',
};

export default savingActionTypes;
